const categoriesNav = document.querySelectorAll(".categories-nav");

if(categoriesNav){
    categoriesNav.forEach((list) => {
        const move = (width, left) => {
            list.querySelector(".categories-nav__line").style.width = `${width}px`;
            list.querySelector(".categories-nav__line").style.left = `${left}px`;
        }

        list.querySelectorAll(".categories-nav__item").forEach((el) => {
            move(list.querySelectorAll(".categories-nav__item")[0].offsetWidth, list.querySelectorAll(".categories-nav__item")[0].offsetLeft);
            el.addEventListener("mouseenter", () => {
                move(el.offsetWidth, el.offsetLeft);
            });
        })
    });
};
